export const filterTags = tags => {
  return tags.filter((tag, index) =>
    tag !== "N/A"
    && tags.indexOf(tag) === index
    && tag !== null
  );
};
